
import StorageService from "@/services/StorageService";
import { Vue } from "vue-class-component";

export default class HeaderTherapist extends Vue {
  private storageService = new StorageService();
  user = null;

  async created() {
    this.user = this.storageService.getUser();
  }
}
